import React, { useState } from "react";
import { Link } from "react-router-dom";
import AuthShell from "./AuthShell";
import api, { apiErr } from "../../lib/api";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Button } from "../../components/ui/button";
import { Mail, ShieldCheck } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setResult(data);
    } catch (err) {
      toast.error(apiErr(err));
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Reset your password"
      subtitle="During the private trial, password resets are handled with founder support."
      footer={<><Link to="/signin" className="text-mint underline underline-offset-4">Back to sign in</Link></>}>
      {result ? (
        <div className="rounded-2xl border border-border p-5 bg-secondary/40" data-testid="reset-support-result">
          <div className="h-11 w-11 rounded-xl bg-mint-light text-mint flex items-center justify-center"><ShieldCheck size={22} /></div>
          <p className="text-sm text-ink mt-4 leading-relaxed">{result.message}</p>
          {result.support_email && (
            <a href={`mailto:${result.support_email}?subject=COMMITMENTT%20password%20reset`}
               className="inline-flex items-center gap-2 mt-4 text-sm text-mint underline underline-offset-4" data-testid="reset-support-email">
              <Mail size={15} />{result.support_email}
            </a>
          )}
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div><Label className="text-ink">Your registered email</Label>
            <Input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 rounded-xl" data-testid="reset-email" /></div>
          <Button type="submit" disabled={loading} className="w-full rounded-full bg-navy text-white hover:bg-navy-light h-11" data-testid="reset-request-submit">
            {loading ? "Please wait…" : "Request a reset"}
          </Button>
          <p className="text-xs text-muted-foreground">
            External email isn't enabled for this trial yet, so a founder will help you reset securely. Real reset emails are ready to switch on later.
          </p>
        </form>
      )}
    </AuthShell>
  );
}
